import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        proteinId: null,
        searchString: null
    },
    mutations: {
        setProteinId(state, payload) {
            state.proteinId = payload
        },
        setSearchString(state, payload) {
            state.searchString = payload
        }
    },
    actions: {},
    modules: {},
    getters: {
        getProteinId: state => {
            return state.proteinId
        }
    },
    plugins: [createPersistedState()]
})
